import { useDispatch } from "react-redux";

import { deleteStudent } from "../../studentSlice";

const DeleteStudentModal = ({
  deleteTarget,
  setDeleteTarget,
  setIsDeleteModalOpen,
}) => {
  const dispatch = useDispatch();

  const confirmDelete = () => {
    if (!deleteTarget) return;
    dispatch(
      deleteStudent({
        studentId: deleteTarget.student.id,
      })
    );
    setIsDeleteModalOpen(false);
    setDeleteTarget(null);
  };

  // [추가] 삭제 모달 닫기
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteTarget(null);
  };

  const styles = {
    button: {
      background: "none",
      border: "none",
      cursor: "pointer",
      height: "24px",
      width: "24px",
    },
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div style={styles.modalOverlay} onClick={closeDeleteModal}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>학생 삭제</div>
        <div style={styles.modalBody}>
          <p style={{ textAlign: "center" }}>
            <strong>정말 {deleteTarget.student.name} 학생 정보를</strong>
          </p>
          <p style={{ textAlign: "center" }}>
            <strong>삭제하시겠습니까?</strong>
          </p>
        </div>
        <div style={styles.modalFooter}>
          <button style={styles.dangerButton} onClick={confirmDelete}>
            네
          </button>
          <button style={styles.cancelButton} onClick={closeDeleteModal}>
            아니오
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteStudentModal;
